<template>
  <div class="pros-exist-user overflow-x-hide">
    <div class="container no-padding">
      <headerlogo :page-type="'1'" />

      <div
        class="row no-padding main-body h-100"
        :style="{ height: windowHeight }"
      >
        <div class="col-sm-12 col-md-12 row my-auto no-padding no-margin">
          <div
            class="col-sm-12 col-12 col-md-12 row no-padding no-margin"
            style="align-items: center"
          >
            <div
              class="col-sm-12 col-md-4 offset-md-2 text-container tab-container no-padding flex-container"
            >
              <div class="content-left">
                <div class="content-sec1">
                  {{ getUiText("app-prospect-callback-whoops-user-heading-1") }}
                </div>
                <div class="content-sec2">
                  <span>{{
                    getUiText("app-prospect-callback-whoops-user-heading-sub-1")
                  }}</span
                  ><br />
                </div>
                <div class="content-sec3">
                  <v-runtime-template :template="userHelpText" />
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 tab-image-container flex-container">
              <img src="@/assets/img/bg3.png" class="img-laptop" />
            </div>
          </div>
        </div>
      </div>
      <errorhandler
        v-if="showProspectCallbackError || null"
        :prospect-callback-error-msg="prospectCallbackErrorMsg"
        @reset-show-prospect-callback-error="resetShowProspectCallbackError"
      />

      <div
        class="footer row d-sm-none d-md-block d-none d-sm-block page-footer no-margin"
      >
        {{ getUiText("app-prospect-nav-cms-text-1") }}
        <a href="https://cybersystem.io">{{
          getUiText("app-prospect-nav-cms-link-1")
        }}</a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from "vue-facing-decorator";
import HeaderLogo from "@/components/common/headerLogo.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import VRuntimeTemplate from "vue3-runtime-template";
import errorhandler from "@/components/common/exceptionHandler.vue";
import store from "@/store";
import $ from "jquery";
@Component({
  components: {
    headerlogo: HeaderLogo,
    VRuntimeTemplate,
    errorhandler,
  },
})
export default class ProspectExistingUser extends Vue {
  public windowHeight = "";
  public showProspectCallbackError = false;
  public prospectCallbackErrorMsg = "";

  public userHelpTextTags: any = {
    "app-prospect-callback-whoops-user-help-link-login-1": {
      openTag: '<a href="javascript:void(0)" @click="onClickLogin()">',
      closeTag: "</a>",
    },
    "app-prospect-callback-whoops-user-help-link-homepage-1": {
      openTag: '<a href="javascript:void(0)" @click="redirectToHomePage()">',
      closeTag: "</a>",
    },
  };

  public userHelpText = "";

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      this.updateUIVariables();
    }, 50);
  }

  created() {
    this.setLanguages();
  }

  mounted() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }

    this.$nextTick(() => {
      window.addEventListener("resize", this.onWindowResize);
      setTimeout(() => {
        this.onWindowResize();
        this.updateUIVariables();
      }, 100);
    });
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }

  getProcessedUIText(id: string, tags: any) {
    return Utils.getProcessedUIText(
      id,
      tags,
      this.languageSelectedText,
      this.defaultUiText,
    );
  }

  updateUIVariables() {
    this.userHelpText =
      "<span>" +
      this.getProcessedUIText(
        "app-prospect-callback-whoops-user-help-text-1",
        this.userHelpTextTags,
      ) +
      "</span>";
  }

  async setLanguages() {
    await Utils.getV3Recaptcha().then(
      async (finalKey: any) => {
        localStorage.removeItem("csrfReloadDone");
        const captchKey = finalKey;
        const recaptcha = await load(`${captchKey}`, {
          autoHideBadge: true,
        });
        recaptcha.execute("submit").then((token) => {
          this.$store.dispatch("LanguagePicker/setLanguages", token);
        });
        recaptcha.execute("submit").then((token) => {
          this.$store.dispatch("LanguagePicker/setLanguageList", token);
        });
      },
      (error: any) => {
        if (error.data.message.toLowerCase() === "invalid csrf token") {
          this.$router.go(0);
        } else {
          this.showErrorInfo(error.data);
        }
      },
    );
  }

  showErrorInfo(errorInfo: any) {
    if (errorInfo && errorInfo !== "") {
      errorInfo =
        typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
      if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
        this.showProspectCallbackError = true;
        this.prospectCallbackErrorMsg = errorInfo.message;
      }
    }
  }
  resetShowProspectCallbackError() {
    this.showProspectCallbackError = false;
    this.prospectCallbackErrorMsg = "";
  }

  onWindowResize() {
    if (window.innerHeight > 750) {
      if (window.innerHeight < 900) {
        if (window.innerWidth > 1800 && window.innerWidth < 2000) {
          this.windowHeight = (window.innerHeight +
            120 +
            "px !important") as string;
        } else if (
          window.innerWidth < 1000 &&
          window.innerHeight > 600 &&
          window.innerHeight < 800
        ) {
          this.windowHeight = (window.innerHeight +
            220 +
            "px !important") as string;
        } else {
          this.windowHeight = (window.innerHeight -
            120 +
            "px !important") as string;
        }
      } else if (window.innerWidth > 800) {
        if (
          window.innerWidth < 1000 &&
          window.innerHeight > 900 &&
          window.innerHeight < 1000
        ) {
          this.windowHeight = (window.innerHeight + "px !important") as string;
        } else if (window.innerHeight < 1200) {
          this.windowHeight = (window.innerHeight -
            160 +
            "px !important") as string;
        } else if (window.innerHeight > 1200) {
          this.windowHeight = (window.innerHeight -
            200 +
            "px !important") as string;
        } else {
          this.windowHeight = (window.innerHeight -
            130 +
            "px !important") as string;
        }
      } else {
        this.windowHeight = (window.innerHeight -
          100 +
          "px !important") as string;
      }
    } else {
      this.windowHeight = "100% !important" as string;
    }
  }
  onClickLogin() {
    this.$router.push({ path: "/user/login" });
  }
  redirectToHomePage() {
    this.$router.push({ path: "/" });
  }
  beforeUnmount() {
    const body = $("body");
    if (!body.hasClass("page-opacity")) {
      body.addClass("page-opacity page-bg");
    }
  }
}
</script>
<style lang="scss" scoped>
.content-left {
  .content-sec1 {
    font-style: normal;
    font-weight: 500;
    font-size: 42px;
    line-height: 140%;
    color: #231f20;
  }
  .content-sec2 {
    margin-top: 25px;
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 170%;
    color: #231f20;
  }
  .content-sec3 {
    margin-top: 39px;
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 170%;
    color: #231f20;

    a {
      text-decoration-line: underline;
      color: #0345bd !important;
    }
  }
}
</style>
